import React from 'react';
import NewVMPage from './NewVMPage';
const NewVMPageContainer = () => {
  return <NewVMPage />;
};
export default NewVMPageContainer;
